import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import familyImage from '@/assets/images/subscription/1.webp';
import { ROUTE_SUBSCRIPTION } from '@/router/routes';

export const SubscriptionBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative h-[140px] overflow-hidden rounded-xl bg-info-surface p-6 contrast:border contrast:border-border">
      <div className="relative z-10 flex w-[212px] flex-col gap-2">
        <p className="text-title-24 text-foreground">
          {t('sidebar.tabs.subscription')}
        </p>
        <p className="text-body-13 text-subtle-foreground">
          {t('other.subscriptionBanner')}{' '}
          <button
            type="button"
            onClick={() => navigate(ROUTE_SUBSCRIPTION)}
            className="cursor-pointer text-primary"
          >
            {t('overview.ratings.paywall.readMore')}
          </button>
        </p>
      </div>
      <img
        src={familyImage}
        alt=""
        aria-hidden
        className="pointer-events-none absolute right-0 bottom-0 h-[130px] w-auto"
      />
    </div>
  );
};
